import { councilDeviceApi } from "@/lib/api"
import type { ApiResponseIntervalFlowDTO, IntervalFlowDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"
interface IntervalFlowParams {
  from: string
  to: string
  currentPage?: number
  pageSize?: number
}

const useGetIntervalFlow = (councilId: string, deviceId: string, params: IntervalFlowParams) => {
  return useQuery({
    queryKey: [useGetIntervalFlow.QUERY_KEY, councilId, deviceId, params],
    queryFn: async () => {
      const response = await councilDeviceApi.getIntervalFlow(
        councilId,
        deviceId,
        params.from,
        params.to,
        params.currentPage,
        params.pageSize,
      )
      return (response.data as ApiResponseIntervalFlowDTO).data as IntervalFlowDTO
    },
    enabled: !!councilId && !!deviceId && !!params?.from && !!params?.to,
  })
}

useGetIntervalFlow.QUERY_KEY = "interval-flow"

export default useGetIntervalFlow
